module.exports = __webpack_public_path__ + "static/media/inclusion-villa-mobile.fa77d3dd.png";